import { language as lan_storeOrdersContent } from "./store-orders-content";
import { language as lan_storeOrdersTip } from "./store-orders-tip";
import { language as lan_importOrders } from "./import-orders";
import { language as lan_importOrdersItems } from "./import-orders-items";

let language = {
    ...lan_storeOrdersContent,
    ...lan_storeOrdersTip,
    ...lan_importOrders,
    ...lan_importOrdersItems
};

export { language }